// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-0d2e0d36]::-webkit-outer-spin-button,\ninput[data-v-0d2e0d36]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number][data-v-0d2e0d36] {\n  -moz-appearance: textfield;\n}\n.reassignment-grid[data-v-0d2e0d36] {\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  grid-template-areas: \"states configs\" \"table table\" \"banner banner\";\n}", ""]);
// Exports
module.exports = exports;
